var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-tertiary btn-lg",attrs:{"disabled":_vm.uploadInProgress},on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.lang.get('buttons.cancel'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }